import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Button, Input, Form, Space, Divider, Dropdown } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import {
	DashOutlined,
	DeleteFilled,
	DeleteOutlined,
	EditOutlined,
	LeftOutlined,
	PlusSquareOutlined,
	SendOutlined,
} from '@ant-design/icons';
import {
	XThemeHeaderBTN,
	XThemeVACheckbox,
	XThemeVAMobileChat,
	XThemeVAMobileHasPadd,
	XThemeVAMobileRecent,
	XThemeVAMobileRecentData,
	XThemeVAMobileRecentFixed,
	XThemeVASubmitBTN,
	XThemeVoiceAssSeeBtn,
	XVALottieMobile,
	XVSLottie,
	XVALottieMobileWrapper,
	XVSLottieWrapper,
	XThemeVAMobileHasFooterFixed,
	XVALottieMobileActionSticky,
	XThemeVSCollapse,
	XThemeVAMobileSumInnerCard,
	XThemeVAMobileSumListCard,
	XThemeVAMobileCollapse,
	XThemeVAMobileDropdown,
} from '../../VoiceAssistanceStyle';
import { XThemeTag } from '../../../../styles/GlobalThemeStyle';
import VSLoaderJson from '../../../../json/loader.json';
import VSdotsAnimation from '../../../../json/dotsAnimation.json';
const items = [
	{
		key: '1',
		label: 'Clinical Summary',
		children: (
			<XThemeVAMobileSumInnerCard>
				<Row>
					<Col xs={24} className="text-end headerBorder">
						<Space>
							<XThemeVASubmitBTN
								size="medium"
								className="radiusBtn"
								shape="square"
								icon={
									<img src="/images/edit-icon.svg" alt="" />
								}
							/>
							<XThemeVASubmitBTN
								size="medium"
								className="radiusBtn"
								shape="square"
								icon={<PlusSquareOutlined />}
							/>
						</Space>
					</Col>
				</Row>
				<Row gutter={[15, 15]}>
					<Col xs={24}>
						<p className="cardPara">
							78F w/ bilateral cataracts but without any
							significant visual impairment is recommended to have
							cataract extraction surgery
						</p>
					</Col>
				</Row>
			</XThemeVAMobileSumInnerCard>
		),
	},
	{
		key: '2',
		label: 'Present Complaint',
		children: (
			<>
				<XThemeVAMobileSumInnerCard>
					<Row className="mb-3">
						<Col xs={24} className="text-end">
							<Space>
								<XThemeVASubmitBTN
									size="medium"
									className="radiusBtn"
									shape="square"
									icon={
										<img
											src="/images/edit-icon.svg"
											alt=""
										/>
									}
								/>
								<XThemeVASubmitBTN
									size="medium"
									className="radiusBtn"
									shape="square"
									icon={<PlusSquareOutlined />}
								/>
							</Space>
						</Col>
					</Row>

					<XThemeVAMobileSumListCard className="mb-3">
						<Row gutter={[10, 10]} className="align-items-center">
							<Col xs={20}>
								<div className="para1">
									Congestive <span>heart failure</span>
								</div>
							</Col>
							<Col xs={4} className="text-end">
								<XThemeVAMobileDropdown
									overlayClassName="vsMobileDropdownOverlapping"
									menu={{
										items: [
											{
												key: '1',
												label: 'Edit',
												icon: <EditOutlined />,
											},
											{
												key: '2',
												label: 'Delete',
												icon: <DeleteOutlined />,
											},
										],
									}}
									placement="bottomRight"
									arrow={{
										pointAtCenter: true,
									}}
								>
									<XThemeVASubmitBTN
										size="medium"
										className="rotateDotButton radiusBtn"
										shape="square"
										icon={<DashOutlined />}
									/>
								</XThemeVAMobileDropdown>
							</Col>
							<Col xs={24} role="button">
								<div className="para2">ICD10:150.9</div>
							</Col>
						</Row>
					</XThemeVAMobileSumListCard>
				</XThemeVAMobileSumInnerCard>
			</>
		),
	},
	{
		key: '3',
		label: 'Past Clinical History',
		children: (
			<>
				<XThemeVAMobileSumListCard className="mb-3">
					<Row gutter={[10, 10]} className="align-items-center">
						<Col xs={20}>
							<div className="para1">
								Congestive <span>heart failure</span>
							</div>
						</Col>
						<Col xs={4} className="text-end">
							<XThemeVAMobileDropdown
								overlayClassName="vsMobileDropdownOverlapping"
								menu={{
									items: [
										{
											key: '1',
											label: 'Edit',
											icon: <EditOutlined />,
										},
										{
											key: '2',
											label: 'Delete',
											icon: <DeleteOutlined />,
										},
									],
								}}
								placement="bottomRight"
								arrow={{
									pointAtCenter: true,
								}}
							>
								<XThemeVASubmitBTN
									size="medium"
									className="rotateDotButton radiusBtn"
									shape="square"
									icon={<DashOutlined />}
								/>
							</XThemeVAMobileDropdown>
						</Col>
						<Col xs={24} role="button">
							<div className="para2">ICD10:150.9</div>
						</Col>
					</Row>
				</XThemeVAMobileSumListCard>
				<XThemeVAMobileSumListCard className="mb-3">
					<Row gutter={[10, 10]} className="align-items-center">
						<Col xs={20}>
							<div className="para1">
								Congestive <span>heart failure</span>
							</div>
						</Col>
						<Col xs={4} className="text-end">
							<XThemeVAMobileDropdown
								overlayClassName="vsMobileDropdownOverlapping"
								menu={{
									items: [
										{
											key: '1',
											label: 'Edit',
											icon: <EditOutlined />,
										},
										{
											key: '2',
											label: 'Delete',
											icon: <DeleteOutlined />,
										},
									],
								}}
								placement="bottomRight"
								arrow={{
									pointAtCenter: true,
								}}
							>
								<XThemeVASubmitBTN
									size="medium"
									className="rotateDotButton radiusBtn"
									shape="square"
									icon={<DashOutlined />}
								/>
							</XThemeVAMobileDropdown>
						</Col>
						<Col xs={24} role="button">
							<div className="para2">ICD10:150.9</div>
						</Col>
					</Row>
				</XThemeVAMobileSumListCard>
				<Row>
					<Col xs={24} className="text-end">
						<XThemeVASubmitBTN
							size="medium"
							className="radiusBtn"
							shape="square"
							icon={<PlusSquareOutlined />}
						>
							Add Past Clinical History
						</XThemeVASubmitBTN>
					</Col>
				</Row>
			</>
		),
	},
	{
		key: '4',
		label: 'Medicare Coverage',
		children: (
			<>
				<XThemeVAMobileSumListCard>
					<Row gutter={[15, 15]} className="align-items-center">
						<Col xs={24}>
							<div className="para1">
								As per the LCD section L33954, The clinical
								summary indicates that the patient, a
								78-year-old female with bilateral cataracts,
								does not have significant visual impairment. The
								coverage indications require that the patient
								has impairment of visual function due to
								cataracts with decreased ability to carry out
								activities of daily living, a best corrected
								visual acuity of 20/50 or worse, or additional
								testing showing a decrease in visual acuity by
								two lines with consensual light or glare
								testing. Since the patient does not have
								significant visual impairment, these criteria
								are not met.
							</div>
							<div className="para1 fst-italic">
								Reference:{' '}
								<Link
									to="https://www.cms.gov/medicare-coverage-database/view/lcd.aspx?LCDId=33954"
									target="_blank"
									className=" text-decoration-underline"
								>
									Centers for Medicare & Medicaid Services
								</Link>
							</div>
						</Col>
					</Row>
				</XThemeVAMobileSumListCard>
			</>
		),
	},
];
const MobileChat8 = () => {
	const [isExpanded, setIsExpanded] = useState(false);

	return (
		<XThemeVAMobileHasFooterFixed
			className={isExpanded ? 'expendedCard' : ''}
		>
			<div className="hasPadding">
				<Row gutter={[15, 10]}>
					<Col xs={20}>
						<div className="cardMainTitle mb-1">Hey Amin,</div>
						<div className="cardSubTitle">
							Can you please press Confirm Coverage
						</div>
					</Col>
					<Col xs={4} className="text-end ">
						<XThemeHeaderBTN
							onClick={() => setIsExpanded(!isExpanded)}
							shape="circle"
							size="large"
							icon={
								isExpanded ? (
									<img
										className="img-fluid"
										src="/images/va-expended-icon.svg"
										alt="Expended"
									/>
								) : (
									<img
										className="img-fluid"
										src="/images/vs-expend-icon.svg"
										alt="Expend"
									/>
								)
							}
						/>
					</Col>
				</Row>
				<div
					className={`cardBackground ${
						isExpanded ? '' : 'notExpended'
					}`}
				>
					<Row gutter={[10, 10]}>
						<Col xs={4}>
							<div className="oddEvenNo">
								2<sup>nd</sup>
							</div>
						</Col>
						<Col xs={20}>
							<div className="cardTitleSmall">
								Mouse MTST
								<span>MGB02</span>
							</div>
							<Row>
								<Col xs={12}>
									<div className="cardTitleSmall">
										<em>MASB02001</em>
									</div>
								</Col>
								<Col xs={12} className="text-end">
									<XThemeTag
										style={{
											background: '#ED982A33',
											color: '#ED982A',
										}}
									>
										Allocated
									</XThemeTag>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row gutter={[15, 10]} className="align-items-center mt-3">
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Insurance</span>
								<br />
								Noridian Healthcare Solutions, LLC
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Hospital</span>
								<br />
								St. Joseph's
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>State</span>
								<br />
								California - Entire State
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>DOB</span>
								<br />
								04-05-1965
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Gender</span>
								<br />
								Male
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Organization</span>
								<br />
								CommonSpirit Health
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Revenue Cycle</span>
								<br />
								Pre Service
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Revenue Cycle Stage</span>
								<br />
								Organization Determination
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Insurance Claim Number</span>
								<br />4
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Providers Encounter Number</span>
								<br />1
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Region</span>
								<br />
								South
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Allocated to</span>
								<br />
								Naaz
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Claim Amount</span>
								<br />-
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Case Amount</span>
								<br />
								$6000
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Discharge Date</span>
								<br />
								01-15-2025
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Hearing Date</span>
								<br />
								01-02-2025
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Admission Date</span>
								<br />
								01-01-2025
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>EOB Date</span>
								<br />
								01-02-2025
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Process Type</span>
								<br />
								MA Standard Appeal Turn-Around-Time (TAT)
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Visit Type</span>
								<br />
								OP
							</div>
						</Col>
						<Col xs={24} sm={12}>
							<div className="para1">
								<span>Status</span>
								<br />
								Allocated
							</div>
						</Col>
						<Col xs={24}>
							<div className="para1">
								<span>Date of Service</span>
								<br />
								01-01-2025, 01-02-2025, 01-03-2025, 01-14-2025,
								01-17-2025, 02-01-2025 to 03-31-2025
							</div>
						</Col>
					</Row>
				</div>
				<Row>
					<Col xs={24}>
						<XThemeVAMobileCollapse
							bordered={false}
							expandIcon={({ isActive }) => (
								<span
									style={{
										transform: `rotate(${
											isActive ? 90 : 270
										}deg)`,
										transition: 'transform 0.3s ease',
									}}
								>
									<img
										class="img-fluid"
										src="/images/chat-back-icon.svg"
										alt=""
									/>
								</span>
							)}
							expandIconPosition="end"
							accordion
							items={items}
						/>
					</Col>
				</Row>
			</div>
			<XVALottieMobileActionSticky>
				<Row gutter={[15, 15]} className="align-items-center">
					<Col xs={12}>
						<Space>
							<XThemeVASubmitBTN
								size="large"
								className="noBackground"
								icon={
									<img
										class="rotateButton"
										src="/images/like-icon.svg"
										alt=""
									/>
								}
							/>
							<XThemeVASubmitBTN
								size="large"
								className="noBackground"
								icon={
									<img src="/images/like-icon.svg" alt="" />
								}
							/>
						</Space>
					</Col>
					<Col xs={12} className="text-end">
						<XThemeVASubmitBTN size="large">
							Confirm Coverage
						</XThemeVASubmitBTN>
					</Col>
				</Row>
			</XVALottieMobileActionSticky>
		</XThemeVAMobileHasFooterFixed>
	);
};

export default MobileChat8;
